import { useEffect, useState } from "react";

import { getMobileOperatingSystem, hRatio, triggerEvent } from "../../constants/utils";
import TextInput from "../../components/TextInput"
import ActionButton from "../../components/ActionButton";
import Styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import { useNavigate } from "react-router-dom";
import UserStore from "../../../stores/UserStore";
import Evolve from "../../icons/Evolve";

const isiOS = getMobileOperatingSystem() === "iOS";
const InputContainerStyle = {
  marginTop: 134 * hRatio,
  backgroundColor: "#f6f1e5",
};

const InputStyle = {
  backgroundColor: "#f6f1e5",
  height: isiOS ? 198 * hRatio : 172 * hRatio,
  fontSize: isiOS ? 69 * hRatio : 54 * hRatio,
};

const InputLabelStyle = {
  backgroundColor: "#f6f1e5",
  height: 48 * hRatio,
  fontSize: isiOS ? 48 * hRatio : 39 * hRatio,
};

const InputErrorStyle = {
  fontSize: isiOS ? 48 * hRatio : 39 * hRatio,
};

const PhoneScreen = () => {
  const navigate = useNavigate();
  //triggering event here
  useEffect(()=>{
    triggerEvent("Phone_Screen_prcstn");
  }, [])
  
  const handleNavigation = () => {
    navigate("/prctn/signup");
  };

  return (
    <div className={Styles.SignUpBG}>
      <div className={Styles.EvolveIcon}>
        <Evolve />
      </div>
      
      <div style={{ height: 216 * hRatio }} />
      <p className={isiOS ? iStyles.SignUpTitle : Styles.SignUpTitle} style={{padding:'1rem'}}>
        Your personalized procrastination <br /> routine awaits!
      </p>
      <p className={isiOS ? iStyles.SignUpSubtitle : Styles.SignUpSubtitle}>
        Don't miss out on building the perfect routine <br/> to transform your life
      </p>
      <img 
        src={require("../../../assets/adhd/Phone.webp")}
        className={Styles.PhoneScreen}
      />
      <img
        src={require("../../../assets/sign_up/sign_up.webp")}
        style={{
          height: "100%",
          width: "100%",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          position: "absolute",
          zIndex: -1,
        }}
      />
      
      <img
        src={require("../../../assets/adhd/cloud2.webp")}
        className={Styles.Cloud3}
      />
      <ActionButton
        buttonStyle={{zIndex:3}}
        text={"Start your free trial"}
        disabled={false}
        onClick={handleNavigation}
      />
    </div>
  );
};

export default PhoneScreen;
